import { Vector3, Shape } from 'three';

const buildRectangle = (left: number, right: number, bottom: number, top: number) => {
    return [
        new Vector3(left, bottom, 0),
        new Vector3(right, bottom, 0),
        new Vector3(right, top, 0),
        new Vector3(left, top, 0),

        new Vector3(left, bottom, 0),
      ];
};

// Function to create a rounded rectangle shape
const createRoundedRectShape = (width: number, height: number, radius: number) => {
  
    const shape = new Shape();
    const angleStep = Math.PI * 0.5;
    
    shape.absarc(width / 2 - radius, height / 2 - radius, radius, angleStep * 0, angleStep * 1);
    shape.absarc(-width / 2 + radius, height / 2 - radius, radius, angleStep * 1, angleStep * 2);
    shape.absarc(-width / 2 + radius, -height    / 2 + radius, radius, angleStep * 2, angleStep * 3);
    shape.absarc(width / 2 - radius, -height / 2 + radius, radius, angleStep * 3, angleStep * 4);

    return shape;
};

export { buildRectangle, createRoundedRectShape }
